<template>
    <div class="page">
        <!-- <div class="title">用户数据分析</div> -->

        <div class="top">
            <div class="ttitle">
                {{topTitle}}
                <div class="right">{{topTime}}</div>
            </div>
            <div class="list">
                <div class="item" v-for="(v,k) in indexArr" :key="k">
                    <img class="left" :src="v.picurl" />
                    <!-- <img class="left" src="../assets/img/index1.png" /> -->
                    <div class="cen">
                        <div>{{v.num}}</div>
                        <div>{{v.typename}}</div>
                    </div>
                    <div class="right">
                        <!-- <div class="ritem" v-for="(vv,kk) in v.arr" :key='kk'>
                            <div>{{vv.nian}}</div>
                            <div>{{vv.bili}}%</div>
                            <img v-if='vv.is_top' src="../assets/img/up.png" />
                            <img v-else src="../assets/img/down.png" />
                        </div> -->
                        <div class="ritem">
                            <div>1年</div>
                            <div>{{v.bili}}%</div>
                            <img v-if='v.is_sheng' src="../assets/img/up.png" />
                            <img v-else src="../assets/img/down.png" />
                        </div>
                        <div class="ritem">
                            <div>3年</div>
                            <div>{{v.bili1}}%</div>
                            <img v-if='v.is_sheng1' src="../assets/img/up.png" />
                            <img v-else src="../assets/img/down.png" />
                        </div>
                        <div class="ritem">
                            <div>5年</div>
                            <div>{{v.bili2}}%</div>
                            <img v-if='v.is_sheng2' src="../assets/img/up.png" />
                            <img v-else src="../assets/img/down.png" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="regionbox">
            <div class="ttitle">
                地区选择
                <el-select v-model="regionVal.pro" placeholder="请选择">
                    <el-option
                        v-for="v in regionArr.pro"
                        :key="v.id"
                        :label="v.classname"
                        :value="v.id"
                    >
                    </el-option>
                </el-select>
                <el-select v-model="regionVal.city" placeholder="请选择">
                    <el-option
                        v-for="v in regionArr.city"
                        :key="v.id"
                        :label="v.classname"
                        :value="v.id"
                    >
                    </el-option>
                </el-select>
                <el-select v-model="regionVal.area" placeholder="请选择">
                    <el-option
                        v-for="v in regionArr.area"
                        :key="v.id"
                        :label="v.classname"
                        :value="v.id"
                    >
                    </el-option>
                </el-select>
                <div class="btns">
                    <div @click='regionSearch()'>搜索</div>
                    <div class="plain" @click='def_article()'>重置</div>
                </div>

                <div class="right">
                    精确查找
                    <el-input v-model="exactFind" placeholder="请输入内容"></el-input>
                    <div class="btns" >
                        <div @click='regionSearch(exactFind)'>搜索</div>
                        <div class="plain" @click="def_article()">重置</div>
                    </div>
                </div>
            </div>
            <div class='regionContent'>
                <div class="mapinfo" v-if='regionInfo.classname'>
                    <div class="ititle">{{regionInfo.classname}}<div></div></div>
                    <div class="icontent" v-html="regionInfo.content">
                        <!-- {{}} -->
                    </div>
                </div>
                <!-- <div class="mapbox">
                    <div id="Map"></div>
                    <div class="base"></div>
                    <div class='dotted'></div>
                </div> -->
                
            </div>
            
        </div>
    </div>
</template>

<script>
import * as echarts from "echarts";
import region from "../mixin/region.js";


// import pro from "../utils/city-data/province.js";
// import city from "../utils/city-data/city.js";

export default {
    name: "Home",
    mixins:[region ],
    data() {
        return {
            exactFind:'',
            regionInfo:{
                classname:'请选择地区',
                content:'',
            },
            regArr:[{ title: '北京市', code: 'beijing', name:'北京' }, { title: '天津市', code: 'tianjin', name:'天津' }, { title: '河北省', code: 'hebei', name:'河北' }, { title: '山西省', code: 'shanxi', name:'山西' }, { title: '内蒙古自治区', code: 'neimenggu', name:'内蒙古' }, { title: '辽宁省', code: 'liaoning', name:'辽宁' }, { title: '吉林省', code: 'jilin', name:'吉林' }, { title: '黑龙江省', code: 'heilongjiang', name:'黑龙江' }, { title: '上海市', code: 'shanghai', name:'上海' }, { title: '江苏省', code: 'jiangsu', name:'江苏' }, { title: '浙江省', code: 'zhejiang', name:'浙江' }, { title: '安徽省', code: 'anhui', name:'安徽' }, { title: '福建省', code: 'fujian', name:'福建' }, { title: '江西省', code: 'jiangxi', name:'江西' }, { title: '山东省', code: 'shandong', name:'山东' }, { title: '河南省', code: 'henan', name:'河南' }, { title: '湖北省', code: 'hubei', name:'湖北' }, { title: '湖南省', code: 'hunan', name:'湖南' }, { title: '广东省', code: 'guangdong', name:'广东' }, { title: '广西壮族自治区', code: 'guangxi', name:'广西' }, { title: '海南省', code: 'hainan', name:'海南' }, { title: '重庆市', code: 'chongqing', name:'重庆' }, { title: '四川省', code: 'sichuan', name:'四川' }, { title: '贵州省', code: 'guizhou', name:'贵州' }, { title: '云南省', code: 'yunnan', name:'云南' }, { title: '西藏自治区', code: 'xizang', name:'西藏' }, { title: '陕西省', code: 'shanxi1', name:'陕西' }, { title: '甘肃省', code: 'gansu', name:'甘肃' }, { title: '青海省', code: 'qinghai', name:'青海' }, { title: '宁夏回族自治区', code: 'ningxia', name:'宁夏' }, { title: '新疆维吾尔自治区', code: 'xinjiang', name:'新疆' }, { title: '香港特别行政区', code: 'xianggang', name:'香港' }, { title: '澳门特别行政区', code: 'aomen', name:'澳门' }, { title: '台湾省', code: 'taiwan', name:'台湾' },],
            indexArr:[],
            topTime:'',
            topTitle:''
        };
    },
    mounted() {
        // console.log(phonetic('四川'));
        // this.aaa();
        // this.aaa('北京市');
        this.mapChart();
        this.$post('/api/tuijiannew').then(res=>{
            // console.log(1111,res);
            this.indexArr = res.data
        })

        this.$post('/api/ba',{id:4}).then(res=>{
            this.topTime = res.data;
        })
        this.$post('/api/ba',{id:3}).then(res=>{
            this.topTitle = res.data;
        })

        this.def_article();
    },
    methods: {
        def_article(){
            this.regionVal = {pro:null, city:null, area:null};
            this.exactFind = '';
            this.mapChart();
            this.$post('/api/area_help').then(res=>{
                // console.log(1111,res);
                this.regionInfo = res.data;
            })
        },
        //地区搜索
        async regionSearch(name = null){
            
            let id = 0, type='pro';
            if(this.regionVal.pro) { id = this.regionVal.pro; type = 'pro' }
            if(this.regionVal.city) { id = this.regionVal.city; type = 'city' }
            if(this.regionVal.area) { id = this.regionVal.area; type = 'area' }
            console.log(id, name);
            if(name == null && id == 0){
                this.$alert('请选择地区'); return;
            }if(name == ''){
                this.$alert('请输入地区'); return;
            }
            
            let res = await this.$post('/api/area_show',{ id: (name == null) ? id : null, name: name  });
            
            this.regionInfo = (res.data != null) ? res.data : {classname:'无查询结果',  content:'',};
            // console.log(res, this.exactFind);
            // return;

            return;
            
            if(name != null){
                if(res.data.parentid == 0){ //省级
                    type = 'pro'
                    for(let i in this.regionArr.pro){
                        if(this.regionArr.pro[i].classname == res.data.classname){
                            this.regionVal.pro = this.regionArr.pro[i].id;
                            break;
                        }
                    }
                }else{
                    let pro_id = 0;
                    for(let i in this.regionArr.pro){
                        if(this.regionArr.pro[i].id == res.data.parentid){
                            pro_id = this.regionArr.pro[i].id;
                            break;
                        }
                    }
                    if(pro_id){ //市级
                        type = 'city'
                        this.regionVal.pro = pro_id;
                        let cityArr = await this.$post('/api/area',{pid: pro_id});
                        this.regionArr['city'] = cityArr.data;
                        for(let i in cityArr.data){
                            if(cityArr.data[i].classname == res.data.classname){
                                this.regionVal.city = cityArr.data[i].id;
                            }
                        }
                    }else{ //区级
                        type = 'area'
                        let proArr = await import("../utils/city-data/province.js");
                        let cityArr = await import("../utils/city-data/city.js");
                        let areaArr = await import("../utils/city-data/area.js");
                        let a, b, c,d;
                        for(let i in areaArr){
                            for(let ii in areaArr[i]){
                                for(let iii in areaArr[i][ii]){
                                    for(let iiii in areaArr[i][ii][iii]){
                                        if(areaArr[i][ii][iii][iiii].label == res.data.classname){
                                            a = i, b = ii, c = iii, d = iiii; break;
                                        }
                                    }
                                    if(d) break;
                                }
                                if(d) break;
                            }
                            if(d) break;
                        }
                        let pro_id, city_id;
                        for(let i in this.regionArr.pro){
                            if(this.regionArr.pro[i].classname == proArr[a][b].label){
                                pro_id = this.regionArr.pro[i].id; break;
                            } 
                        }
                        this.regionVal.pro = pro_id;
                        let cityArr1 = await this.$post('/api/area',{pid: pro_id});
                        this.regionArr['city'] = cityArr1.data;
                        for(let i in this.regionArr.city){
                            if(this.regionArr.city[i].classname == cityArr[a][b][c].label){
                                city_id = this.regionArr.city[i].id; break;
                            } 
                        }
                        this.regionVal.city = city_id;
                        let areaArr1 = await this.$post('/api/area',{pid: city_id});
                        this.regionArr['area'] = areaArr1.data;
                        for(let i in this.regionArr.area){
                            if(this.regionArr.area[i].classname == areaArr[a][b][c][d].label){
                                this.regionVal['area'] = this.regionArr.area[i].id; break;
                            } 
                        }
                    }
                }
            }
            this.mapChart(res.data.classname, type);

            // if(type == 'pro'){
            //     console.log(1111);
            //     for(let i in this.regionArr.pro){
            //         console.log(this.regionArr.pro[i].id, this.regionVal.pro);
            //         if(this.regionArr.pro[i].id == this.regionVal.pro){

            //             this.mapChart(this.regionArr.pro[i].className, 'pro'); 
            //             break;
            //         }
            //     }
            // }else{
            //     // console.log(this.regionArr.city, this.regionVal.city);
            //     for(let i in this.regionArr.city){
            //         if(this.regionArr.city[i].id == this.regionVal.city){
            //             this.mapChart(this.regionArr.city[i].className, 'city'); 
            //             break;
            //         }
            //     }
            // }


        },
        
        async mapChart(name='', type= 'pro')  {
            // console.log(2222,name, type);
            let regCode = 'china', regName='china', cityArr = [];
            if( type == 'pro'){
                await import("echarts/map/js/china.js");
                // for(let i in this.regionArr.pro){
                //     cityArr[i] = {
                //         name: this.regionArr.pro[i].classname,
                //         value : (this.regionArr.pro[i].classname == name) ? 2 : 0
                //     }
                //     // console.log(this.regionArr.pro[i].classname , name, this.regionArr.pro[i].classname == name);
                // }
                for (let i in this.regArr){
                    cityArr[i] = {
                        name: this.regArr[i].name,
                        value : (name.indexOf(this.regArr[i].name)!= -1) ? 2 : 0
                    }
                }
            }else{
                let proName;
                for(let i in this.regionArr.pro){
                    if(this.regionVal.pro == this.regionArr.pro[i].id){
                        proName = this.regionArr.pro[i].classname;
                        break;
                    }
                }
                console.log(3333,proName);
                for(let i in this.regArr){
                    console.log(this.regArr[i].title, proName);
                    if(this.regArr[i].title == proName){
                        regCode = this.regArr[i].code;
                        regName = this.regArr[i].name;
                        break;
                    }
                }
                // console.log(222,regCode,regName,cityArr);

                await import("echarts/map/js/province/"+regCode+".js");

                for(let i in this.regionArr.city){
                    cityArr[i] = {
                        name: this.regionArr.city[i].classname,
                        value : (this.regionArr.city[i].classname == name) ? 2 : 0
                    }
                }

            }
            // cityArr = [];

            // console.log(111,regCode,regName,cityArr);

            var option = {

                visualMap: {
                    min: 0,
                    max: 2,
                    show: false,
                    color: ["#0071C1", "#BFBFBF"],
                },
                selectedMode: "single",
                geo: {
                    map: regName,
                    // 地图类型
                    mapType: regCode, //对应省份,中文（如：广东
                    // 底层添加边框
                    itemStyle: {
                        normal: {
                            shadowOffsetX: 0,
                            shadowOffsetY: 2,
                            areaColor: "rgba(0,0,0,.3)",
                            shadowBlur: 5,
                            borderColor: "#ffffff",
                            borderWidth: 5,
                        },

                    },
                    label:{
                        show: false,
                        emphasis:{
                            show: false,
                        }
                    },
                    emphasis:{
                        disabled:true
                    },
                },
                series: [
                    {
                        type: "map",
                        map: regName,
                        mapType: regCode, //对应省份,中文（如：广东）
                        zoom: 1,
                        itemStyle: {
                            normal: {
                                areaColor: "#BFBFBF",
                                borderColor: "#FFFFFF",
                                borderWidth: 2,
                            },
                            emphasis: {
                                show: false,
                                areaColor: null,
                                label: {
                                    color: "#000000",
                                },
                            }
                        },
                        showLegendSymbol: true,
                        label: {
                            normal: {
                                textStyle: {
                                    fontSize: 10,
                                    color: "#000000",
                                },
                                show: true,
                            },
                            emphasis: {
                                show: false,
                            },
                        }, 
                        data: cityArr,
                        
                    },
                ],
            };
            if(regName == '海南'){
                option.series[0].center = [108.5, 19.3];
                option.series[0].layoutCenter = ['35%', '50%'];
                option.series[0].layoutSize = "500%";
                option.geo.center = [108.5, 19.3];
                option.geo.layoutCenter = ['35%', '50%'];
                option.geo.layoutSize = "500%";
            }
            // var myChartContainer = ;
            echarts.init(document.getElementById("Map")).dispose(); //销毁

            var myChartChina = echarts.init(document.getElementById("Map"));
            myChartChina.setOption(option);

            myChartChina.on("click", (params) => { //点击事件
                    console.log('我被点击了',params.name);
                this.regionSearch(params.name);
                    
            });
        },
    },
};
</script>


<style lang="scss" scoped>
.page {
    padding: 26px 38px 30px;
    .title {
        height: 44px;
        line-height: 44px;
        font-size: 24px;
        color: #111;
        .right {
            float: right;
            height: 44px;
            .search {
                width: 350px;
                height: 44px;
                padding: 10px 18px;
                background: #fff;
                border-radius: 5px;
                box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.1);
                margin-right: 16px;
                float: left;
                img {
                    float: right;
                }
                input {
                    height: 100%;
                    float: left;
                    width: calc(100% - 40px);
                    border: 0;
                    font-size: 14px;
                }

                display: inline-block;
            }
            .btn {
                height: 44px;
                width: 82px;
                line-height: 44px;
                text-align: center;
                background: #0755a7;
                color: #fff;
                font-size: 16px;
                border-radius: 5px;
                display: inline-block;
                float: left;
                margin-right: 26px;
            }
        }
    }
    .ttitle {
        padding: 5px 25px 0;
        border-bottom: solid 1px #eeeff1;
        font-size: 18px;
        color: #444;
        line-height: 50px;
        position: relative;
        &::before {
            content: " ";
            position: absolute;
            height: 6px;
            width: 6px;
            background: #0956a8;
            left: 11px;
            bottom: 22px;
        }
        .right {
            float: right;
            color: #666;
            font-size: 16px;
        }
    }
    .top {
        background: #fff;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        margin-top: 18px;
        .list {
            height: 225px;
            width: 100%;
            padding: 25px 50px;
            .item {
                padding-left: 20px;
                width: 25%;
                float: left;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: space-around;
                position: relative;
                &::before {
                    content: " ";
                    width: 2px;
                    height: 96px;
                    background: #f3f4f6;
                    position: absolute;
                    right: -1px;
                    top: calc(50% - 48px);
                }
                &:last-child::before {
                    display: none;
                }
            }
            .cen {
                div:nth-child(1) {
                    font-size: 22px;
                    font-weight: bold;
                    color: #3c434d;
                }
                div:nth-child(2) {
                    font-size: 16px;
                    color: #999;
                    max-width: 180px;
                    padding-right:20px;
                }
            }
            .right {
                width: 140px;
                .ritem {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    height: 46px;
                    border-bottom: solid 1px #f3f4f6;
                    margin-right: 10px;
                    img {
                        margin-right: -10px;
                    }
                }
            }
        }
    }
    .regionbox {
        background: #fff;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        margin-top: 18px;
        .ttitle{
            >>> .el-input__inner{
                height:36px;
                width:160px;
                border: 1px solid #0756A3;
                margin-left:12px;
            }
            >>> .el-input__icon{
                height:auto;
            }
            .btns {
                display: inline-block;
                // margin-top:1px;
                // padding: 0 0 0 22px;
                div {
                    width: 68px;
                    height: 35px;
                    border-radius: 5px;
                    text-align: center;
                    border: solid 1px #0155b8;
                    background: #0155b8;
                    color: #fff;
                    line-height: 33px;
                    display: inline-block;
                    font-size:16px;
                    // float:left;
                    margin-left: 12px;
                    cursor: pointer;
                    &.plain {
                        background: #fff;
                        color: #999;
                        border: solid 1px #ccc;

                    }
                }
            }
            .right{
                position:relative;
                padding-left:25px;
                width:650px;
                &::before {
                    content: " ";
                    position: absolute;
                    height: 6px;
                    width: 6px;
                    background: #0956a8;
                    left: 11px;
                    bottom: 22px;
                }
                .el-input{
                    width:auto;
                }
            }
        }
        .regionContent{
            // min-height:700px;
            .mapinfo{
                // width:670px;
                width:calc(100% - 70px);
                // float:left;
                display:inline-block;
                border-top:solid 4px #0557A3;
                box-shadow: 0 0 10px #b1d9ff;
                padding:25px;
                margin:35px;
                // max-height:460px;
                // height:460px;
                position: relative;
                
                .ititle{
                    font-size:18px;
                    font-weight:600;
                    color:#666;
                    div{
                        transform: scale(1, .5);
                        height:14px;
                        width:14px;
                        position: relative;
                        display:inline-block;
                        margin-left:10px;
                        &::before{
                            content:" ";
                            position: absolute;
                            background:linear-gradient(45deg, #0557A3 50%, #fff 50%);
                            height:100%;
                            width:100%;
                            transform: rotate(45deg);

                        }
                    }
                }
                .icontent{
                    margin-top:20px;
                    color:#575757;
                    font-size:14px;
                    line-height:24px;
                    height:calc(100% - 50px);
                    overflow-y: auto;
                    padding-bottom:30px;
                    >>> img{
                        max-width:900px;
                    }
                    
                    &::-webkit-scrollbar {
                        width: 5px;    
                        border-left:solid 10px #fff;
                    }
                    &::-webkit-scrollbar-thumb {
                        border-radius: 10px;
                        box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
                        background: rgba(0,0,0,0.2);
                    }
                    &::-webkit-scrollbar-track {
                        box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
                        border-radius: 10px;
                        background: rgba(0,0,0,0.1);

                    }
                    
                }
                &::before{
                    content:" ";
                    position: absolute;
                    bottom:30px;
                    left:25px;
                    width:calc(100% - 55px);
                    height:44px;
                    background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
                    pointer-events: none;
                }
            }
            .mapbox{
                width:calc(100% - 740px);
                height:460px;
                float:right;
                position: relative;
                z-index:1;
                #Map{
                    height:100%;
                    width:100%;
                }
                .base{
                    width:300px;
                    height:300px;
                    transform: scale(1, .55);
                    position: absolute;
                    z-index:-1;
                    bottom:-90px;
                    left:calc(50% - 150px);

                    &::before{
                        content:"";
                        position: absolute;
                        height:100%;
                        width:100%; 
                        background:red; 
                        box-sizing: border-box;
                        background: #E0E8F3;
                        border:solid 40px #F2F5FA;
                        transform: rotate(40deg);
                    }
                }
                .dotted{
                    position: absolute;
                    border:dashed 2px #E4E7EC;
                    border-top:0;
                    border-left:0;
                    height:100px;
                    width:150px;

                    top:50%;
                    left:-10px;
                    transform: skew(-20deg, 0);

                }
            }
            
        }
    }

    /* */
}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue